import React from "react";
import { Leaf, Droplets, CalendarCheck } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const benefits = [{
  title: "Ağız Sağlığının Önemi",
  description: "Sağlıklı bir gülüş sadece estetik bir tercih değil, genel vücut sağlığınızın temel taşıdır. Diş sağlığınızı koruyarak yaşam kalitenizi artırıyoruz.",
  icon: Leaf
}, {
  title: "Kişiye Özel Yaklaşım",
  description: "Her hastamızın hikayesi ve ihtiyaçları farklıdır. Size özel hazırlanan tedavi planları ile doğal ve kalıcı sonuçlara odaklanıyoruz.",
  icon: Droplets
}, {
  title: "Konforlu Tedavi Süreci",
  description: "Son teknoloji donanımlarımız ve uzman kadromuzla, tedavi sürecinizin her aşamasında maksimum konfor ve güven sağlıyoruz.",
  icon: CalendarCheck
}];
export default function SubscriptionBenefits() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="34195" id="why-its-important-our-care-approach" ref={ref} className="bg-background py-32 relative overflow-hidden">
      <div className="container mx-auto px-4">
        <div className={cn("grid grid-cols-1 md:grid-cols-3 gap-8 transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
          {benefits.map((benefit, i) => <div key={i} data-index={i} className="h-full">
              <Card className="h-full border border-border bg-card shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-lg hover:border-primary group">
                <CardHeader className="pb-4">
                  <div className="mb-6 inline-flex items-center justify-center rounded-full bg-secondary p-3 w-fit group-hover:bg-accent transition-colors">
                    <benefit.icon className="size-8 text-primary" strokeWidth={1.5} />
                  </div>
                  <CardTitle className="text-[32px] font-serif font-medium text-foreground leading-tight">
                    {benefit.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-base text-muted-foreground leading-relaxed font-sans">
                    {benefit.description}
                  </CardDescription>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}